(function($) {

	var inputs = document.querySelectorAll( '.inputfile' );
	Array.prototype.forEach.call( inputs, function( input )
	{
		var label	 = input.nextElementSibling,
			labelVal = label.innerHTML;

		input.addEventListener( 'change', function( e )
		{
			var fileName = '';
			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else
				fileName = e.target.value.split( '\\' ).pop();

			if( fileName )
				label.querySelector( 'span' ).innerHTML = fileName;
			else
				label.innerHTML = labelVal;
		});

		// Firefox bug fix
		input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
		input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
	});

	/**
	 * Request a Quote file upload
	 */
	$(document).on('click', '.ginput_container_fileupload', function(e) {
		$(this).find('input[type=file]').trigger('click');
	});

	$(document).on('click', '.ginput_container_fileupload input[type=file]', function(e) {
		e.stopPropagation();
	});

	$(document).on('change', '.ginput_container_fileupload input[type=file]', function(e) {
		let file = $(this).val();

		//Strip out the rest to get just the file name
		file = file.split("\\");
		file = file[file.length-1];

		if (file) {
			$('.ginput_container_fileupload').attr('data-file', file).addClass('hasFile');
		}
		else {
			$('.ginput_container_fileupload').removeClass('hasFile').attr('data-file', '');
		}
	});

})(jQuery);
